// modules
import React, { useEffect } from 'react';
// hooks
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom/dist';
import { useTranslation } from 'react-i18next';
// redux
import { getCourseBySlug, detailCourseSelect } from 'redux-api/slices/courseSlice';
// constants
import { REQUEST_STATUSES } from 'common/constants';
// components
import { Title, Ticker, InfoPartialComponent } from 'components/Base';
import { Information, Technologies } from 'components/DetailCourse';
import StudentReviews from 'components/StudentReviews/StudentReviews';
import EducationProcessComponent from 'components/EducationProcess/EducationProcessComponent';
import TeachersMentors from 'components/TeachersMentors/TeachersMentors';
import StudentCompany from 'components/studentCompany/StudentCompany';
import StudentQuestions from 'components/StudentQuestions/StudentQuestions';
import { detailEducationProcess, getEducationProcess } from 'redux-api/slices/educationProcessSlice';
// style
import { Helmet } from 'react-helmet-async';
import classes from './DetailCourse.module.scss';


const DetailCourse = () => {

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { course, courseStatus } = useSelector(detailCourseSelect);

  const { educationProcess, educationProcessStatus } = useSelector(detailEducationProcess);

  const {
    extended_name,
    description,
    start_date,
    start_time,
    end_time,
    title,
    days_of_week,
    info_blocks,
    duration,
    price,
    lessons_amount,
    teachers_count,
    image,
    technologies,
    teachers,
    mentors,
    image_alt,
    course_name_info,
    title_meta,
    description_meta,
    keywords
  } = course;

  const { slug } = useParams();

  const titleData = {
    title: extended_name,
    description,
    days_of_week,
    start_date,
    start_time,
    end_time,
    title_meta,
    description_meta,
    keywords
  };

  const infoData = {
    duration,
    price,
    lessons_amount,
    teachers_count,
    image,
    image_alt
  };

  const educationData = {
    title: t('HowIsTheTraining'),
    data: educationProcess,
    status: educationProcessStatus === REQUEST_STATUSES.SUCCEEDED,
  };

  const infoBlock = (position) => {
    const data = info_blocks?.[ position ];

    const aosData = {
      'data-aos': 'fade-up',
      'data-aos-anchor-placement': 'top-bottom',
      'data-aos-duration': 800,
      'data-aos-offset': 200,
    };

    const whiteBlockContent = 'center';
    if (data) {
      return (
        <InfoPartialComponent
          myClass={position === 'bottom' || position === 'end' ? classes.bottom : classes.mb}
          aosData={aosData}
          title={data?.title}
          BtnIsArrow={true}
          arrayCardsInfo={data?.contents}
          theme={ position === whiteBlockContent ? 'white' : 'black' }
          themeBtn={ position === whiteBlockContent ? 'yellow' : 'white'}
          titleUnderText={data?.thesis}
        />
      );
    };

    return <></>;
  };

  useEffect(() => {
    dispatch(getEducationProcess());
  }, [ dispatch ]);

  useEffect(() => {
    dispatch(getCourseBySlug(slug));

    return () => null;
  }, [ dispatch, slug ]);
  const dataQuestion = course_name_info?.[ 0 ];
  if (courseStatus !== REQUEST_STATUSES.SUCCEEDED) return null;
  return (
    <>
      <Helmet>
        <title>{titleData.title_meta}</title>
        <meta name='description' content={titleData.description_meta}/>
        <meta name='keywords' content={titleData.keywords} />
      </Helmet>
      <Title isThePlace={true} data={titleData}/>
      <Ticker>{title}</Ticker>
      <Information data={infoData}/>
      {infoBlock('top')}
      {infoBlock('pre_center')}
      <StudentReviews/>
      <StudentCompany/>
      {infoBlock('center')}
      <Technologies data={technologies}/>
      <EducationProcessComponent {...educationData}/>
      <TeachersMentors title={t('Teachers')} data={teachers}/>
      <TeachersMentors title={t('Mentors')} data={mentors}/>
      {infoBlock('bottom')}
      {infoBlock('end')}
      <StudentQuestions title={dataQuestion?.thesis} data={dataQuestion?.course_questions_thesis}/>
    </>
  );
};

export default DetailCourse;
